/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountSearchResult,
  EligibilityCheckResponse,
  PartnerOutput,
  PartnerSearchByBrResult,
  PartnerSearchResponse,
  PartnersBrSearchRequest,
  PartnersSearchRequest,
} from '../models/index';
import {
    AccountSearchResultFromJSON,
    AccountSearchResultToJSON,
    EligibilityCheckResponseFromJSON,
    EligibilityCheckResponseToJSON,
    PartnerOutputFromJSON,
    PartnerOutputToJSON,
    PartnerSearchByBrResultFromJSON,
    PartnerSearchByBrResultToJSON,
    PartnerSearchResponseFromJSON,
    PartnerSearchResponseToJSON,
    PartnersBrSearchRequestFromJSON,
    PartnersBrSearchRequestToJSON,
    PartnersSearchRequestFromJSON,
    PartnersSearchRequestToJSON,
} from '../models/index';

export interface GetAccountSearchResultRequest {
    accountNumber: string;
}

export interface GetPartnerRequest {
    partnerUid: string;
}

export interface IsPartnerEligibleRequest {
    partnerUid: string;
}

export interface SearchPartnersRequest {
    partnersSearchRequest?: PartnersSearchRequest;
}

export interface SearchPartnersBrRequest {
    brUid: string;
    partnersBrSearchRequest?: PartnersBrSearchRequest;
}

/**
 * 
 */
export class PartnersApi extends runtime.BaseAPI {

    /**
     * Creates request options for getAccountSearchResult without sending the request
     */
    async getAccountSearchResultRequestOpts(requestParameters: GetAccountSearchResultRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accountNumber'] == null) {
            throw new runtime.RequiredError(
                'accountNumber',
                'Required parameter "accountNumber" was null or undefined when calling getAccountSearchResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partners/account/{accountNumber}`;
        urlPath = urlPath.replace(`{${"accountNumber"}}`, encodeURIComponent(String(requestParameters['accountNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrievs account data for a given account number
     * Retrievs account data for a given account number
     */
    async getAccountSearchResultRaw(requestParameters: GetAccountSearchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountSearchResult>> {
        const requestOptions = await this.getAccountSearchResultRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountSearchResultFromJSON(jsonValue));
    }

    /**
     * Retrievs account data for a given account number
     * Retrievs account data for a given account number
     */
    async getAccountSearchResult(requestParameters: GetAccountSearchResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountSearchResult> {
        const response = await this.getAccountSearchResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPartner without sending the request
     */
    async getPartnerRequestOpts(requestParameters: GetPartnerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling getPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partners/{partnerUid}`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns partner information if available
     * Retrieve partner information
     */
    async getPartnerRaw(requestParameters: GetPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerOutput>> {
        const requestOptions = await this.getPartnerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerOutputFromJSON(jsonValue));
    }

    /**
     * Returns partner information if available
     * Retrieve partner information
     */
    async getPartner(requestParameters: GetPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerOutput> {
        const response = await this.getPartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for isPartnerEligible without sending the request
     */
    async isPartnerEligibleRequestOpts(requestParameters: IsPartnerEligibleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerUid'] == null) {
            throw new runtime.RequiredError(
                'partnerUid',
                'Required parameter "partnerUid" was null or undefined when calling isPartnerEligible().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/partners/{partnerUid}/isEligible`;
        urlPath = urlPath.replace(`{${"partnerUid"}}`, encodeURIComponent(String(requestParameters['partnerUid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the list of eligibility checks
     * Check if given partner is eligible to access to a list of features
     */
    async isPartnerEligibleRaw(requestParameters: IsPartnerEligibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EligibilityCheckResponse>> {
        const requestOptions = await this.isPartnerEligibleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EligibilityCheckResponseFromJSON(jsonValue));
    }

    /**
     * Returns the list of eligibility checks
     * Check if given partner is eligible to access to a list of features
     */
    async isPartnerEligible(requestParameters: IsPartnerEligibleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EligibilityCheckResponse> {
        const response = await this.isPartnerEligibleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPartners without sending the request
     */
    async searchPartnersRequestOpts(requestParameters: SearchPartnersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partners/search`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnersSearchRequestToJSON(requestParameters['partnersSearchRequest']),
        };
    }

    /**
     * Returns partners matching the provided search term. Used for partner lookup and typeahead functionality.
     * Search partners by name or partner number
     */
    async searchPartnersRaw(requestParameters: SearchPartnersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartnerSearchResponse>>> {
        const requestOptions = await this.searchPartnersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerSearchResponseFromJSON));
    }

    /**
     * Returns partners matching the provided search term. Used for partner lookup and typeahead functionality.
     * Search partners by name or partner number
     */
    async searchPartners(requestParameters: SearchPartnersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartnerSearchResponse>> {
        const response = await this.searchPartnersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchPartnersBr without sending the request
     */
    async searchPartnersBrRequestOpts(requestParameters: SearchPartnersBrRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['brUid'] == null) {
            throw new runtime.RequiredError(
                'brUid',
                'Required parameter "brUid" was null or undefined when calling searchPartnersBr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/partnersBr/{brUid}/search`;
        urlPath = urlPath.replace(`{${"brUid"}}`, encodeURIComponent(String(requestParameters['brUid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnersBrSearchRequestToJSON(requestParameters['partnersBrSearchRequest']),
        };
    }

    /**
     * Returns partners matching the provided search term and related to the given business relation.
     * Search partners by name or partner number for a business relation
     */
    async searchPartnersBrRaw(requestParameters: SearchPartnersBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartnerSearchByBrResult>> {
        const requestOptions = await this.searchPartnersBrRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerSearchByBrResultFromJSON(jsonValue));
    }

    /**
     * Returns partners matching the provided search term and related to the given business relation.
     * Search partners by name or partner number for a business relation
     */
    async searchPartnersBr(requestParameters: SearchPartnersBrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartnerSearchByBrResult> {
        const response = await this.searchPartnersBrRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
